export const BULK_ACTION_LIMIT = 20;
